export const AdapterType = {
    MQTT: 1,
    MQTTS: 2,
    HTTPS: 3,
};